import type { FaireProductEntity } from "../../entity_types/product";

export const p_ncgwmju2ve: FaireProductEntity = {
  token: "p_ncgwmju2ve",
  type: "product",
  name: "Insect Repellent",
  brandToken: "b_cm73zmtk8g",
  brandName: "Sage & Stone Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/5fcf3e2a1616978cbc636b882ba4269bc5655b1984cf2c9a7fda42cb157fc0b5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/57df781d93161045fea2d23307466b8269d73452609bd023016e5c31c1903bc6.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "Introducing our powerful and reliable insect repellent, your ultimate defense against pesky bugs and irritating insect bites. Our insect repellent is specially formulated to keep you protected from a wide range of insects, allowing you to enjoy the outdoors without any worries. \nWith a unique blend of effective ingredients, our repellent creates a barrier on your skin that deters mosquitoes, ticks, gnats, flies, and other biting insects. It provides long-lasting protection, keeping these bothersome bugs at bay for hours, so you can focus on enjoying your time outdoors without constantly swatting or scratching. \nNot only does our insect repellent effectively repel insects, but it also has a pleasant scent that won't overpower your senses. Say goodbye to the strong, unpleasant odors commonly associated with insect repellents. Our formula is designed to provide effective protection while keeping you feeling fresh. \nThe convenient spray bottle design allows for easy and precise application, ensuring thorough coverage on exposed skin. It is also gentle on the skin, making it suitable for the whole family, including children. \nWhether you're camping, hiking, gardening, or simply spending time in your backyard, our insect repellent is your trusted companion. Don't let insects ruin your outdoor adventures. Stay protected with our reliable and effective insect repellent and enjoy the great outdoors without any interruptions.",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:13.647Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
